import axios from 'axios'

/* var axiosDefaultsBaseURL=process.env.VUE_APP_URL;
// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axiosDefaultsBaseURL = false;
}
else if (process.env.NODE_ENV == 'production') {
    axiosDefaultsBaseURL = process.env.VUE_APP_URL;
} */

function apiAxios(axiosConfig) {



    const service = axios.create({
        // eslint-disable-next-line no-undef
        baseURL: process.env.VUE_APP_URL, // 设置统一的请求前缀
        // baseURL: axiosDefaultsBaseURL, // 设置统一的请求前缀
        timeout: 10000, // 设置统一的超时时长
    })

    // 实例添加请求拦截器
    service.interceptors.request.use(function (config) {
        return Promise.resolve(config)
    }, function (error) {
        // 对请求错误做处理...
        return Promise.reject(error)
    })

    // 实例添加响应拦截器
    service.interceptors.response.use(function (response) {
        return Promise.resolve(checkStatus(response))
    }, function (error) {
        // 对响应错误做处理...
        if (error.response) {
            return Promise.reject(checkStatus(error.response))
        } else if (
            error.code == 'ECONNABORTED' &&
            error.message.indexOf('timeout') != -1
        ) {
            return Promise.reject({ msg: '请求超时' })
        } else {
            return Promise.reject({})
        }
    })

    /**
     * http返回状态码检查
     * @param response
     * @returns {{msg: string, status: number}|*}
     */
    function checkStatus(response) {
        const status = response.status || -1000 // -1000 自己定义，连接错误的status
        if ((status >= 200 && status < 300) || status === 304) {
            // 如果http状态码正常，则直接返回数据
            return response.data
        } else {
            let errorInfo = ''
            switch (status) {
                case -1:
                    errorInfo = '远程服务响应失败,请稍后重试'
                    break
                case 400:
                    errorInfo = '400：错误请求'
                    break
                case 401:
                    errorInfo = '401：访问令牌无效或已过期'
                    break
                case 403:
                    errorInfo = '403：拒绝访问'
                    break
                case 404:
                    errorInfo = '404：资源不存在'
                    break
                case 405:
                    errorInfo = '405：请求方法未允许'
                    break
                case 408:
                    errorInfo = '408：请求超时'
                    break
                case 500:
                    errorInfo = '500：访问服务失败'
                    break
                case 501:
                    errorInfo = '501：未实现'
                    break
                case 502:
                    errorInfo = '502：无效网关'
                    break
                case 503:
                    errorInfo = '503：服务不可用'
                    break
                default:
                    errorInfo = '连接错误'
            }
            return {
                status,
                msg: errorInfo,
                response:response,
            }
        }
    }

    return service(axiosConfig)
}



export default apiAxios
